import { Popover } from "antd";

const Notes = ({ value }) => {
  return value ? (
    <Popover
      placement="right"
      content={
        <span className="text-grayBlack text-xs font-medium">
          {value}
        </span>
      }
      overlayClassName="event-shift-popover"
    >
      <p className="text-grayBlack text-xs font-medium w-fit line-clamp-4">
        {value}
      </p>
    </Popover>
  ) : (
    <p className="text-grayBlack text-xs font-medium">N/A</p>
  );
};

export default Notes;
